import React from 'react';
import VoxelButton, { VoxelButtonProps } from '../Buttons/VoxelButton';

export interface VoxelDialogActionButtonProps extends VoxelButtonProps { }

export const VoxelDialogActionButton: React.FC<VoxelDialogActionButtonProps> = ({ ...props }) => {
  return <VoxelButton shape="square" color="white" size="lg" type="button" {...props} />;
};

export default VoxelDialogActionButton;
